import React, { Fragment } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { string, bool, shape, func } from "prop-types";
import { goBack, push } from "connected-react-router";

import { selectors as sessionSelectors } from "reducers/session";
import { actions as loginActions } from "reducers/login";

import GeneralMsg from "pages/_components/GeneralMsg";
import Image from "pages/_components/Image";
import Navbar from "react-bootstrap/lib/Navbar";
import ErrorBoundary from "pages/_components/ErrorBoundary";
import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";

import * as i18n from "util/i18n";

class Error extends React.Component {
    static propTypes = {
        dispatch: func.isRequired,
        hasActiveSession: bool.isRequired,
        isMobile: bool,
        location: shape({
            code: string,
            message: string,
        }).isRequired,
    };

    static defaultProps = {
        isMobile: false,
    };

    componentDidMount() {
        const { dispatch, location } = this.props;
        const { code } = location;
        if (code === "COR041E") {
            dispatch(
                loginActions.goBackToLoginAndShowMessage(
                    i18n.get("administration.restrictions.unavailableEnvironment"),
                ),
            );
        }
        window.common.hideSplashScreen();

        document.title = "Bi-Bank - Error page";
    }

    getContent = () => {
        const { hasActiveSession, location } = this.props;
        const { message } = location;
        const { code } = location;
        const isBackoffice = window.self !== window.top;

        if (!code && !isBackoffice) {
            return <Redirect to="/desktop" />;
        }

        const errorTitle = i18n.get(
            `error.title.${code}`,
            "En este momento la Banca Electrónica BiBank no se encuentra disponible.",
        );

        let errorMessage = message || i18n.get(`returnCode.${code}`);
        if (!errorMessage || errorMessage === `*returnCode.${code}*`) {
            errorMessage = "Por favor, intentá más tarde o comunicate con el banco.";
        }

        const acceptCodes = ["API554W", "BAK586E"];
        let errorBack = acceptCodes.includes(code) ? i18n.get("global.accept") : i18n.get("error.back");
        if (!errorBack || errorBack === "error.back") {
            errorBack = "Volver";
        }

        const btnHandlerOnClick = () => {
            const { dispatch } = this.props;
            dispatch(push(hasActiveSession ? "/desktop" : dispatch(goBack())));
        };

        const button = code !== "COR086E" && !isBackoffice && (
            <Button
                className="btn btn-primary btn-block"
                defaultLabelText={errorBack}
                onClick={btnHandlerOnClick}
                block
            />
        );

        const imgPath =
            code === "API554W" ? "figma/illustrations/onboarding14.svg" : "figma/illustrations/onboarding14.svg";
        return (
            <MainContainer>
                <div className="above-the-fold">
                    <GeneralMsg
                        title={errorTitle}
                        errorCode={code === "BAK586E" ? code : null}
                        description={errorMessage}
                        imagePath={imgPath}
                        callToAction={button}
                    />
                </div>
            </MainContainer>
        );
    };

    getMobileLayout = () => (
        <ErrorBoundary>
            <div className="view-wrapper theme-auth">{this.getContent()}</div>
        </ErrorBoundary>
    );

    getDesktopLayout = () => {
        const isBackoffice = window.self !== window.top;

        return (
            <ErrorBoundary>
                <div className="app theme-auth enrollment-layout">
                    <header className="app-header">
                        {!isBackoffice && (
                            <Navbar collapseOnSelect fluid>
                                <Navbar.Header>
                                    <div className="container-navbar">
                                        <Navbar.Brand>
                                            <Link className="navbar-brand" to="/desktop">
                                                <Image src="images/logoCompany.svg" />
                                            </Link>
                                        </Navbar.Brand>
                                    </div>
                                </Navbar.Header>
                            </Navbar>
                        )}
                    </header>

                    <div className="app-page">
                        <div className="app-content">
                            <div className="view-wrapper theme-auth">{this.getContent()}</div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    };

    render() {
        const { isMobile } = this.props;
        return isMobile ? (
            <Fragment>{this.getMobileLayout()}</Fragment>
        ) : (
            <Fragment>{this.getDesktopLayout()}</Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: sessionSelectors.isLoggedIn(state),
});

export default connect(mapStateToProps)(Error);
